/* walleu-social-popup — open/close behavior for the contact launcher.
   The launcher <button> carries aria-expanded (source of truth); the
   wrapper mirrors it as .is-open for the CSS. Escape, the close button
   and outside clicks close the panel; focus moves into the panel on
   open and back to the launcher on close. On small screens (fullscreen
   sheet) the page scroll is locked while open — re-evaluated if the
   viewport crosses the breakpoint while open (device rotation). */
(() => {
  const MOBILE = window.matchMedia('(max-width: 499px)');

  class WalleuSocialPopup extends HTMLElement {
    connectedCallback() {
      this.launcher = this.querySelector('.walleu-social-popup__launcher');
      this.panel = this.querySelector('.walleu-social-popup__panel');

      this.launcher.addEventListener('click', () => this.toggle());

      this.querySelector('.walleu-social-popup__close').addEventListener('click', () => {
        this.toggle(false);
        this.launcher.focus();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.isOpen) {
          this.toggle(false);
          this.launcher.focus();
        }
      });

      document.addEventListener('click', (event) => {
        if (this.isOpen && !this.contains(event.target)) {
          this.toggle(false);
        }
      });

      MOBILE.addEventListener('change', () => this.syncScrollLock());
    }

    get isOpen() {
      return this.launcher.getAttribute('aria-expanded') === 'true';
    }

    toggle(force = !this.isOpen) {
      this.launcher.setAttribute('aria-expanded', String(force));
      this.classList.toggle('is-open', force);
      this.syncScrollLock();

      if (force) {
        this.panel.focus({ preventScroll: true });
      }
    }

    syncScrollLock() {
      if (this.isOpen && MOBILE.matches) {
        document.documentElement.style.overflow = 'hidden';
      } else {
        document.documentElement.style.removeProperty('overflow');
      }
    }
  }

  if (!window.customElements.get('walleu-social-popup')) {
    window.customElements.define('walleu-social-popup', WalleuSocialPopup);
  }
})();
